import { render, staticRenderFns } from "./EnergyConsumption.vue?vue&type=template&id=270b06b1&scoped=true&"
import script from "./EnergyConsumption.vue?vue&type=script&lang=js&"
export * from "./EnergyConsumption.vue?vue&type=script&lang=js&"
import style0 from "./EnergyConsumption.vue?vue&type=style&index=0&id=270b06b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b06b1",
  null
  
)

export default component.exports